import React, { Component } from 'react';
import { Modal } from 'synfrastructure';
import { Carousel as RRCarousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.css';

import Icon from '../../../../common/icons/Icon';

class Carousel extends Component {
  state = {
    modalVisible: false,
  };

  handleToggleModal = () => {
    this.setState((state, props) => ({
      modalVisible: !state.modalVisible,
    }));
  };

  renderVideoPlayer = () => {
    if (!this.state.modalVisible) {
      return null;
    }

    return (
      <video
        className="video-player"
        controls
        poster="https://d27vybgvtr1dba.cloudfront.net/golf-schools/carousel-1@0.25x.jpg"
        src="https://d27vybgvtr1dba.cloudfront.net/golf-schools/golf-school-carousel.mp4"
      />
    );
  };

  renderVideoModal = () => {
    return (
      <Modal isVisible={this.state.modalVisible} onClose={this.handleToggleModal}>
        <div className="modal__content--alt">
          <div className="video-player__modal-container">{this.renderVideoPlayer()}</div>
        </div>
      </Modal>
    );
  };

  renderCarousel() {
    return (
      <RRCarousel
        className="carousel__wrapper"
        infiniteLoop
        showArrows
        showIndicators={false}
        showStatus={false}
        showThumbs={false}
      >
        <div className="slide-content">
          <button className="fullscreen-play" onClick={this.handleToggleModal}>
            <Icon icon="PlayCircle" />
            <img
              srcSet="https://d27vybgvtr1dba.cloudfront.net/golf-schools/carousel-1@1x.jpg 1800w, https://d27vybgvtr1dba.cloudfront.net/golf-schools/carousel-1@0.75x.jpg 1350w, https://d27vybgvtr1dba.cloudfront.net/golf-schools/carousel-1@0.5x.jpg 900w, https://d27vybgvtr1dba.cloudfront.net/golf-schools/carousel-1@0.25x.jpg 450w"
              sizes="100vw"
              src="https://d27vybgvtr1dba.cloudfront.net/golf-schools/carousel-1@0.25x.jpg"
              alt="Tathata Golf Schools"
            />
          </button>
        </div>
        <div className="slide-content">
          <img
            srcSet="https://d27vybgvtr1dba.cloudfront.net/golf-schools/carousel-2@1x.jpg 1800w, https://d27vybgvtr1dba.cloudfront.net/golf-schools/carousel-2@0.75x.jpg 1350w, https://d27vybgvtr1dba.cloudfront.net/golf-schools/carousel-2@0.5x.jpg 900w, https://d27vybgvtr1dba.cloudfront.net/golf-schools/carousel-2@0.25x.jpg 450w"
            sizes="100vw"
            src="https://d27vybgvtr1dba.cloudfront.net/golf-schools/carousel-2@0.25x.jpg"
            alt="Tathata Golf Schools"
          />
        </div>
        <div className="slide-content">
          <img
            srcSet="https://d27vybgvtr1dba.cloudfront.net/golf-schools/carousel-3@1x.jpg 1800w, https://d27vybgvtr1dba.cloudfront.net/golf-schools/carousel-3@0.75x.jpg 1350w, https://d27vybgvtr1dba.cloudfront.net/golf-schools/carousel-3@0.5x.jpg 900w, https://d27vybgvtr1dba.cloudfront.net/golf-schools/carousel-3@0.25x.jpg 450w"
            sizes="100vw"
            src="https://d27vybgvtr1dba.cloudfront.net/golf-schools/carousel-3@0.25x.jpg"
            alt="Tathata Golf Schools"
          />
        </div>
        <div className="slide-content">
          <img
            srcSet="https://d27vybgvtr1dba.cloudfront.net/golf-schools/carousel-4@1x.jpg 1800w, https://d27vybgvtr1dba.cloudfront.net/golf-schools/carousel-4@0.75x.jpg 1350w, https://d27vybgvtr1dba.cloudfront.net/golf-schools/carousel-4@0.5x.jpg 900w, https://d27vybgvtr1dba.cloudfront.net/golf-schools/carousel-4@0.25x.jpg 450w"
            sizes="100vw"
            src="https://d27vybgvtr1dba.cloudfront.net/golf-schools/carousel-4@0.25x.jpg"
            alt="Tathata Golf Schools"
          />
        </div>
        <div className="slide-content">
          <img
            srcSet="https://d27vybgvtr1dba.cloudfront.net/golf-schools/carousel-5@1x.jpg 1800w, https://d27vybgvtr1dba.cloudfront.net/golf-schools/carousel-5@0.75x.jpg 1350w, https://d27vybgvtr1dba.cloudfront.net/golf-schools/carousel-5@0.5x.jpg 900w, https://d27vybgvtr1dba.cloudfront.net/golf-schools/carousel-5@0.25x.jpg 450w"
            sizes="100vw"
            src="https://d27vybgvtr1dba.cloudfront.net/golf-schools/carousel-5@0.25x.jpg"
            alt="Tathata Golf Schools"
          />
        </div>
        <div className="slide-content">
          <img
            srcSet="https://d27vybgvtr1dba.cloudfront.net/golf-schools/carousel-6@1x.jpg 1800w, https://d27vybgvtr1dba.cloudfront.net/golf-schools/carousel-6@0.75x.jpg 1350w, https://d27vybgvtr1dba.cloudfront.net/golf-schools/carousel-6@0.5x.jpg 900w, https://d27vybgvtr1dba.cloudfront.net/golf-schools/carousel-6@0.25x.jpg 450w"
            sizes="100vw"
            src="https://d27vybgvtr1dba.cloudfront.net/golf-schools/carousel-6@0.25x.jpg"
            alt="Tathata Golf Schools"
          />
        </div>
        <div className="slide-content">
          <img
            srcSet="https://d27vybgvtr1dba.cloudfront.net/golf-schools/carousel-7@1x.jpg 1800w, https://d27vybgvtr1dba.cloudfront.net/golf-schools/carousel-7@0.75x.jpg 1350w, https://d27vybgvtr1dba.cloudfront.net/golf-schools/carousel-7@0.5x.jpg 900w, https://d27vybgvtr1dba.cloudfront.net/golf-schools/carousel-7@0.25x.jpg 450w"
            sizes="100vw"
            src="https://d27vybgvtr1dba.cloudfront.net/golf-schools/carousel-7@0.25x.jpg"
            alt="Tathata Golf Schools"
          />
        </div>
        <div className="slide-content">
          <img
            srcSet="https://d27vybgvtr1dba.cloudfront.net/golf-schools/carousel-8@1x.jpg 1800w, https://d27vybgvtr1dba.cloudfront.net/golf-schools/carousel-8@0.75x.jpg 1350w, https://d27vybgvtr1dba.cloudfront.net/golf-schools/carousel-8@0.5x.jpg 900w, https://d27vybgvtr1dba.cloudfront.net/golf-schools/carousel-8@0.25x.jpg 450w"
            sizes="100vw"
            src="https://d27vybgvtr1dba.cloudfront.net/golf-schools/carousel-8@0.25x.jpg"
            alt="Tathata Golf Schools"
          />
        </div>
      </RRCarousel>
    );
  }

  render() {
    return (
      <div>
        {this.renderCarousel()}
        {this.renderVideoModal()}
      </div>
    );
  }
}

export default Carousel;



// WEBPACK FOOTER //
// ./src/subscription/coaching/golf-schools/carousel/Carousel.js